import React from 'react';

import Hero from '../../components/Common/Hero/Hero';
import MetaData from '../../components/Common/MetaData/MetaData';
import AboutBio from '../../components/About/AboutBio';
import ContactUs from '../../components/Common/ContactUs/ContactUs';

import AboutHero from '../../assets/images/heros/about-us-hero.png';
import MichaelArnett from '../../assets/images/headshots/Michael-Arnett.jpg';

import AmyArnett from '../../assets/images/headshots/Amy-Arnett.jpg';
import NicoleG  from '../../assets/images/headshots/Nicole-G.jpg';
import MeaganE from '../../assets/images/headshots/Meagan-E.jpg';
import RasheedJ from '../../assets/images/headshots/Rasheed-J.jpg';
import RobertT from '../../assets/images/headshots/Rob-T.jpg';
import BrimleyN from '../../assets/images/headshots/Brimley-N.jpg';
import BrianR from '../../assets/images/headshots/Brian-R.jpg';
import ThongN from '../../assets/images/headshots/Thong-N.jpg';
import BradG from '../../assets/images/headshots/Brad-G.jpg';
import AlexT from '../../assets/images/headshots/Alex-T.png';
import Mallory from '../../assets/images/headshots/Mallory.jpg';
import Matthew from '../../assets/images/headshots/Matthew.png';

import NCMABadge from '../../assets/images/partners/NCMA_Badge.png';
import ELEVBadge from '../../assets/images/partners/ELEV_Badge.png';
import ELEVBadge2025 from '../../assets/images/partners/badge-elev-2025.png';
import ELEVBadge2026 from '../../assets/images/partners/badge-elev-2026.png';

export default function OurTeam() {

  return (
    <div className="About">

      <MetaData
        title="Meet Our Team"
        description="The team of BNL Consulting"
        image={AboutHero}
      />

      <Hero
        image={AboutHero}
        title="TEAM"
        detail="Get to know us"
      />

      <div className="container">

        <p className="lead pt-5 pb-3">
          From innovative developers to strategic thinkers, every member plays a vital role in delivering exceptional solutions to our clients. Meet the brilliant minds behind our projects and discover how their dedication drives innovation, fuels growth, and ensures we exceed expectations every step of the way.
        </p>
      </div>

      <div className="container">
        <hr className="my-5"/>
        <AboutBio
          image={NicoleG}
          name="Nicole"
          title=""
          bio1="Operations Administrator who thrives on streamlining daily operations and ensuring smooth workflows. In her free time, you'll find her exploring the world of culinary creations, with the goal of creating an amazing future cookbook full of delicious recipes."
          bio2=""
        />
        <hr className="my-5"/>
        <AboutBio
          image={MeaganE}
          name="Meagan"
          title=""
          bio1="Meagan Edney is the Director of Operations at BNL Consulting, where she oversees financial, business, and employee operations with a strong focus on efficiency and fiscal stewardship. With ten years of experience spanning program administration, she excels at creating streamlined processes and maintaining a positive, healthy work environment for all."
          bio2=""
        />
        <hr className="my-5"/>
        <AboutBio
          image={AmyArnett}
          name="Amy"
          title=""
          bio1="With more than a decade of experience in Federal Sales Development, Amy Arnett drives growth by leading her team with energy and vision from one opportunity to the next. As a Shipley-trained Capture Manager, she applies proven methodologies to position BNL for success across the federal marketplace. Amy has partnered with agencies such as the Department of Health and Human Services, the U.S. Census Bureau, the Department of Agriculture, and the Centers for Disease Control and Prevention, consistently ensuring clients receive tailored, results-driven solutions. She also champions BNL's commitment to quality, highlighting the firm's ISO 9001 and CMMI Level III certifications as cornerstones of reliable delivery. Recognized for her dedication to client success, Amy goes beyond the proposal process to cultivate lasting partnerships that advance agency missions."
          bio2=""
        />
        <hr className="my-5"/>
        <AboutBio
          image={MichaelArnett}
          name="Mike"
          title=""
          bio1="Seasoned IT professional and the CEO at BNL Consulting. A die-hard Georgia Bulldogs fan and a proud finisher of an impressive 20-mile walk-a-thon at the young age of eight."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          name="Jason"
          title=""
          bio1="As the Director of Web Development, Jason finds it intrinsically rewarding to build the first layer of interaction between a user and the intricate world behind the scenes."
          bio2=""
        />
        <hr className="my-5"/>

        <AboutBio
          name="George"
          title=""
          bio1="Well-honed Senior Systems Engineer who thrives on the versatility of his role. George is actively involved in his community, dedicating his free time to coaching girls' softball, leading a Cub Scout Den, and pursuing a passion for crafting with wood and leather."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={RasheedJ}
          name="Rasheed"
          title=""
          bio1="Experience software professional with a strong passion for building innovative and efficient technology solutions. With experience spanning JavaScript, Java, Full Stack Development, cloud platforms and data-driven applications, he thrives on on turning complex challenges into practical, user-friendly systems. An avid sports fan cheering for the Jacksonville Jaguars and Tampa Bay Lightning."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={RobertT}
          name="Robert"
          title=""
          bio1="Robert Tabit is the Managing Partner of BNL Consulting, where he leads business development and federal sales efforts. He focuses on building strategic partnerships, guiding solution strategy, and helping agencies modernize IT systems with secure, scalable, and user-centered solutions."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={BrimleyN}
          name="Brimley"
          title=""
          bio1="Brimley Newton is the Director of Systems Administration at BNL Consulting, where he maintains the company's IT infrastructure and supports customer environments. He recently welcomed his first daughter and spends his downtime on family walks, story time, and celebrating tiny milestones. On weekends, he also enjoys trips to the beach and fishing with his wife."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={BrianR}
          name="Brian"
          title=""
          bio1="Brian Rygwalski is a dedicated project manager and consultant with a strong background in business intelligence, analytics, and technology leadership. He holds a Master of Science in Management Information Technology and has successfully led projects across both the public and private sectors. Brian is known for blending strategic thinking with hands-on problem solving, helping teams and clients reach their goals efficiently. His work spans process improvement, system modernization, and creating solutions that make a measurable impact. Colleagues value his approachable leadership style and ability to keep complex projects on track while fostering collaboration. Based in Lulu, Florida, Brian enjoys spending time with his family and exploring the outdoors when he’s not managing projects."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={ThongN}
          name="Thong"
          title=""
          bio1="Senior SAS Developer with experience in data engineering. He’s also an avid World Traveler & Foodie who enjoys immersing himself in local experiences, savoring regional cuisine, and trying new drinks while taking in the sights."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          name="Denys"
          title=""
          bio1="Skilled Data Engineer & BI Specialist. His expertise bridges the gap between data engineering and business intelligence, enabling organizations to make data-driven decisions. In his free time, he loves to read about history."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={BradG}
          name="Brad"
          title=""
          bio1="Senior Vice President of Implementation As the Senior VP of Implementation, I oversee the successful execution of key projects and initiatives across the organization. I lead cross-functional teams to ensure that every implementation aligns with our strategic goals, stays on schedule, and meets the highest standards of quality."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={AlexT}
          name="Alex"
          title=""
          bio1="Project management intern and a current senior at the University of Georgia studying computer science. I love to hike, camp, mountain bike and do anything outdoors."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={Mallory}
          name="Mallory"
          title=""
          bio1="Administrative and operations assistant. Mallory has a background in policy research and assists our administrative team with daily operations and logistics."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          image={Matthew}
          name="Matthew"
          title=""
          bio1="Matthew is a dedicated sales professional supporting business development at BNL Consulting. With a background in Public Administration and a strong focus on detail, he enjoys building relationships and contributing to team success."
          bio2=""
        />

        <hr className="my-5"/>
        <AboutBio
          name="Anne"
          title=""
          bio1="Anne specializes in building modern, intuitive, and scalable interfaces with expertise in TypeScript, React, and front-end development. She excels at transforming complex requirements into seamless digital experiences while ensuring creative vision is elevated through thoughtful, high-quality implementation. When she's not coding, you'll likely find her hanging around a soccer field with a book in hand."
          bio2=""
        />

      </div>

      <div className="p-2 background-dark-blue d-flex justify-content-center">

        <div className="d-inline-block p-1 p-md-4">
          <img src={NCMABadge} alt="NCMA 2023 Badge" height={180}/>
        </div>

        <div className="d-inline-block p-3">
          <img src={ELEVBadge} alt="ELEV 2024 Badge" height={180}/>
        </div>

        <div className="d-inline-block p-3">
          <img src={ELEVBadge2025} alt="ELEV 2025 Badge" height={180}/>
        </div>

        <div className="d-inline-block p-3">
          <img src={ELEVBadge2026} alt="ELEV 2026 Badge" height={180}/>
        </div>

      </div>

      <ContactUs
        message="Are you interested in joining our team?"
        buttonText="Current Job Postings"
        href="https://www.indeed.com/cmp/Bnl-Consulting"
      />

    </div>
  );
}
